import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'arm-action-bar',
  templateUrl: './action-bar.component.html',
  styleUrls: ['./action-bar.component.scss']
})
export class ActionBarComponent implements OnInit {

  @Input() disableAdd;
  @Input() addTooltip;
  @Output() addClick: any = new EventEmitter<any>();
  showAdd;

  @Input() disableEdit;
  @Input() editTooltip;
  @Output() editClick: any = new EventEmitter<any>();
  showEdit;

  @Input() deleteTooltip;
  @Input() disableDelete;
  @Output() deleteClick: any = new EventEmitter<any>();
  showDelete;

  @Input() refreshTooltip;
  @Input() disableRefresh;
  @Output() refreshClick: any = new EventEmitter<any>();
  showRefresh;

  constructor() { }

  ngOnInit(): void {
    this.showAdd = this.addClick.observers.length  > 0;
    this.showEdit = this.editClick.observers.length  > 0;
    this.showDelete = this.deleteClick.observers.length  > 0;
    this.showRefresh = this.refreshClick.observers.length  > 0;
  }

  onEdit(): void{
    this.editClick.emit();
  }

  onAdd(): void{
    this.addClick.emit();
  }

  onDelete(): void{
    this.deleteClick.emit();
  }

  onRefresh(): void{
    this.refreshClick.emit();
  }

}
